import { pdf } from "@react-pdf/renderer";
import { apiRequest } from "./axiosConfig";
import { PdfReport } from "utils/pdfGenerator";

// Fetch properties with filters
export const fetchPropertiesFromAPI = async (filters, nextUrl) => {
  const url = nextUrl ? nextUrl : `/api/properties/search?limit=10`;
  return apiRequest("post", url, filters);
};

// Add external property
export const addExternalPropertiesFromAPI = async (
  organizerListId,
  externalUrl
) => {
  const url = `/api/properties/extract`;
  return apiRequest("post", url, { url: externalUrl, organizerListId });
};

// Save custom external property
export const saveCustomExternalPropertyAPI = async (
  organizerListId,
  propertyTitle,
  propertyPrice,
  propertyImage,
  externalUrl
) => {
  let formData = new FormData();
  formData.append("image", propertyImage);
  formData.append("organizerListId", organizerListId);
  formData.append("title", propertyTitle);
  formData.append("price", propertyPrice);
  formData.append("url", externalUrl);

  const customHeaders = {
    "Content-Type": "multipart/form-data",
  };

  const url = `/api/properties/customExternal`;
  return apiRequest("post", url, formData, customHeaders);
};

// Fetch external properties
export const fetchExternalPropertiesFromAPI = async (
  organizerListId,
  nextUrl
) => {
  if (!organizerListId) return;
  const url = nextUrl
    ? nextUrl
    : `/api/properties/external?organizerListId=${organizerListId}&limit=10`;
  return apiRequest("get", url);
};

// Remove external property
export const removeExternalPropertyFromAPI = async (
  organizerListId,
  propertyId
) => {
  const url = `/api/properties/external/${propertyId}`;
  return apiRequest("delete", url, { organizerListId });
};

// Update external property note
export const updateExternalProperty = async (
  propertyId,
  organizerListId,
  note
) => {
  return apiRequest("put", "/api/properties/external/note", {
    propertyId,
    organizerListId,
    note,
  });
};

// Fetch map properties coordinates without pagination
export const fetchMapProperties = async (filters) => {
  const url = "/api/properties/map";
  return apiRequest("post", url, filters);
};

// Get individual property details by property _id
export const fetchPropertyDetails = async (propertyId) => {
  const url = `/api/properties/details/${propertyId}`;
  return apiRequest("get", url);
};

// Add a doubt property
export const addDoubtPropertyToAPI = async (propertyId, averageGrossYield) => {
  return apiRequest("post", "/api/doubtProperties", {
    propertyId,
    averageGrossYield,
  });
};

// Fetch doubt properties
export const fetchDoubtPropertiesFromAPI = async (
  isPopulateProperty,
  nextUrl
) => {
  const url = nextUrl
    ? nextUrl
    : `/api/doubtProperties?populateProperty=${isPopulateProperty}&limit=10`;
  return apiRequest("get", url);
};

// Remove a doubt property
export const removeDoubtPropertyFromAPI = async (propertyId) => {
  return apiRequest("delete", `/api/doubtProperties/${propertyId}`);
};

// Add a discarded property
export const addDiscardedPropertyToAPI = async (
  propertyId,
  averageGrossYield
) => {
  return apiRequest("post", "/api/discardedProperties", {
    propertyId,
    averageGrossYield,
  });
};

// Fetch discarded properties
export const fetchDiscardedPropertiesFromAPI = async (
  isPopulateProperty,
  nextUrl
) => {
  const url = nextUrl
    ? nextUrl
    : `/api/discardedProperties?populateProperty=${isPopulateProperty}&limit=10`;
  return apiRequest("get", url);
};

// Remove a discarded property
export const removeDiscardedPropertyFromAPI = async (propertyId) => {
  return apiRequest("delete", `/api/discardedProperties/${propertyId}`);
};

// Fetch lowest price per square meter properties for dashboard
export const fetchLowestPricePerSquareMeterProperty = async () => {
  const url = `/api/properties/lowestPricePerSqm`;
  return apiRequest("get", url);
};

// Fetch top gross yield properties for dashboard
export const fetchTopGrossYieldProperty = async () => {
  const url = `/api/properties/topGrossYield`;
  return apiRequest("get", url);
};

// Fetch chart properties for dashboard
export const fetchMarketStatistics = async (filters) => {
  const url = `/api/properties/statistics`;
  return apiRequest("post", url, filters);
};

// Fetch nearby market statistics for property details
export const fetchNearbyMarketStatistics = async (propertyId) => {
  const url = `/api/properties/nearby-statistics/${propertyId}`;
  return apiRequest("get", url);
};

export const sendHouseReportPDF = async (
  reportData,
  emails,
  isInvite = false
) => {
  let formData = new FormData();

  if (isInvite) {
    formData.append("file", reportData, "report.pdf");
  } else {
    const blob = await pdf(<PdfReport reportData={reportData} />).toBlob();
    formData.append("file", blob, "report.pdf");
  }

  formData.append("emails", JSON.stringify(emails));

  const customHeaders = {
    "Content-Type": "multipart/form-data",
  };

  const url = "/api/properties/sendHouseReport";
  try {
    await apiRequest("post", url, formData, customHeaders);
  } catch (error) {
    throw new Error(error);
  } finally {
    return isInvite ? null : formData.get("file");
  }
};
